import {
  SITEMAP_APPROVAL_ROUTE,
  SITEMAP_SUBMITTED_ROUTE,
} from 'constants/RouteConstants';

/** Browser history basename from CreateHistory — window.location includes this. */
export const MYEV_APP_BASENAME = '/myev';

/**
 * True for open (unauthenticated) sitemap email pages.
 * Accepts history paths (/sitemap-approval) and browser paths (/myev/sitemap-approval).
 */
export const isOpenSitemapPath = (pathname = '') => {
  if (!pathname || typeof pathname !== 'string') return false;

  const hasMyevBasename = pathname.startsWith(`${MYEV_APP_BASENAME}/`)
    || pathname === MYEV_APP_BASENAME;
  const withoutBasename = hasMyevBasename
    ? (pathname.slice(MYEV_APP_BASENAME.length) || '/')
    : pathname;

  return withoutBasename.startsWith(SITEMAP_APPROVAL_ROUTE)
    || withoutBasename.startsWith(SITEMAP_SUBMITTED_ROUTE);
};
